import CaptionText from 'components/common/CaptionText';
import { Course } from 'types/course';
import FlexContainer from 'components/common/FlexContainer';
import { ReactComponent as GradCapSVG } from 'images/grad-cap.svg';
import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';
import useTranslation from 'hooks/use-translation';

export const SubjectHeading = styled.span({
  fontWeight: fontStyles.weights.medium,
});

export const TargetSubjectsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: 28,
  padding: '20px 24px 20px 0px',
  [mobileMediaQuery]: {
    flexDirection: 'column',
    flex: 'initial',
    justifyContent: 'initial',
    padding: 0,
  },
});

type Props = {
  courses: Course[];
};

export function AvailableCoursesContent(props: Props): JSX.Element | null {
  const { courses } = props;
  const translation = useTranslation();

  if (!translation) {
    return null;
  }

  if (courses.length === 0) {
    return null;
  }

  const text = courses.length === 1 ? translation.courseTerminology.base : translation.courseTerminology.plural;

  return (
    <FlexContainer flexDirection='row' alignItems='center' gap={4}>
      <CoursesCaptionText className='available-in-course-label'>Available in</CoursesCaptionText>
      <GradCapIcon className='available-in-course-icon' />
      <CoursesCaptionText className='available-in-course-label'>{`${courses.length} ${text}`}</CoursesCaptionText>
    </FlexContainer>
  );
}

const CoursesCaptionText = styled(CaptionText)({
  color: fontStyles.colors.primary,
});

const GradCapIcon = styled(GradCapSVG)({
  width: 16,
  height: 16,
});
